import { composeU, withBemMod } from '@bem-react/core';
import React, { FC, ReactElement, useMemo } from 'react';

import {
    StreamPoster as StreamPosterBase,
    withSizeL as withStreamPosterSizeL,
    withSizeM as withStreamPosterSizeM,
    withSizeS as withStreamPosterSizeS,
} from 'components/StreamPoster';

import { WithTypeCurrent } from './StreamsList_type_current.interface';
import { StreamsListProps } from '../StreamsList.interface';
import { cnStreamsList } from '../StreamsList';
import { MAX_STREAMS } from '../StreamsList.constants';
import { getSize } from '../StreamsList.util';

const StreamPoster = composeU(
    withStreamPosterSizeL,
    withStreamPosterSizeM,
    withStreamPosterSizeS,
)(StreamPosterBase);

export const withTypeCurrent = withBemMod<WithTypeCurrent, StreamsListProps>(
    cnStreamsList(),
    { type: 'current' },
    (StreamsList): FC<WithTypeCurrent & StreamsListProps> =>
        (props: WithTypeCurrent & StreamsListProps): ReactElement => {
            const {
                streams,
                isAdmin,
                isAllStreamsVisible,
                getNavigationCallback,
                onActionsStreamPosterClick,
                onViewersCounterClick,
                onStreamPosterDescriptionClick,
                onStreamPosterTitleTextClick,
                onHintClick,
            } = props;

            const posters = useMemo(() => {
                const buffer = [];

                for (let i = 0; i < streams.length; i++) {
                    if (!isAllStreamsVisible && i >= MAX_STREAMS) break;

                    const stream = streams[i];
                    buffer.push((
                        <StreamPoster
                            type="current"
                            key={stream.id}
                            isTvButtonVisible={isAdmin}
                            size={getSize(i, streams.length) as undefined}
                            viewers={stream.viewersCount}
                            description={stream.streamDescription}
                            name={stream.name}
                            info={stream.streamDescription}
                            templateId={stream.templateId}
                            id={stream.id}
                            eventId={stream.eventId}
                            startTime={stream.startTime}
                            streamPosterUrl={stream.streamPicture}
                            onStreamPosterClick={getNavigationCallback(`/streams/${stream.id}`)}
                            onChatClick={getNavigationCallback(`/streams/${stream.id}/chat`)}
                            onTvChatClick={getNavigationCallback(`/streams/${stream.id}/chat?tv-view=1`)}
                            onActionsStreamPosterClick={onActionsStreamPosterClick}
                            onViewersCounterClick={onViewersCounterClick}
                            onStreamPosterDescriptionClick={onStreamPosterDescriptionClick}
                            onStreamPosterTitleTextClick={onStreamPosterTitleTextClick}
                            onHintClick={onHintClick}
                        />
                    ));
                }

                return buffer;
            }, [
                getNavigationCallback,
                isAllStreamsVisible,
                onActionsStreamPosterClick,
                onHintClick,
                onStreamPosterDescriptionClick,
                onStreamPosterTitleTextClick,
                onViewersCounterClick,
                streams,
                isAdmin,
            ]);

            return (
                <StreamsList
                    {...props}
                    posters={posters}
                />
            );
        },
);
